import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f9117c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body mt-3 d-md-flex d-none justify-content-around" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-header fs-5 lh-1 mb-5" }, " Days ", -1))
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-header fs-5 lh-1 mb-5" }, " Times ", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-header fs-5 lh-1 mb-5" }, " Course Tags ", -1))
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "tooltip-wrapper" }
const _hoisted_11 = { class: "tooltip-text" }

import { computed } from 'vue'
import BsCheckbox from '@/components/BsCheckbox/BsCheckbox.vue'
import { MicroFilter, FilterValue, filterDays, filterTimes } from './SessionSeach.interfaces'
import { CourseTag } from '@/types/api'
import InfoCircle from '@/icons/InfoCircleStraight.vue'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'MicroFilterAccordion',
  props: {
    microFilter: {},
    courseTags: {},
    sessions: {}
  },
  emits: ['update:micro-filter'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const sessionTags = computed(() =>
  props.courseTags.filter((tag: CourseTag) =>
    props.sessions.some((session: SessionListItemViewModel) =>
      session.tags?.includes(tag.abbreviation) ?? false
    )
  )
)

const emit = __emit

const updateDayFilter = (day: FilterValue) => {
  const microfilter: MicroFilter = JSON.parse(JSON.stringify(props.microFilter))
  microfilter.days = microfilter.days.some((d: FilterValue) => d.value === day.value)
    ? microfilter.days.filter((d: FilterValue) => d.value !== day.value)
    : [...microfilter.days, day]

  emit('update:micro-filter', microfilter)
}

const updateTimeFilter = (time: FilterValue) => {
  const microfilter: MicroFilter = JSON.parse(JSON.stringify(props.microFilter))
  microfilter.times = microfilter.times.some((t: FilterValue) => t.value === time.value)
    ? microfilter.times.filter((t: FilterValue) => t.value !== time.value)
    : [...microfilter.times, time]

  emit('update:micro-filter', microfilter)
}

const updateTagFilter = (tag: CourseTag) => {
  const abbreviation = tag.abbreviation

  const microfilter: MicroFilter = JSON.parse(JSON.stringify(props.microFilter))
  microfilter.tags = microfilter.tags.includes(abbreviation)
    ? microfilter.tags.filter((t: string) => t !== abbreviation)
    : [...microfilter.tags, abbreviation]

  emit('update:micro-filter', microfilter)
}

function getShortenedTagTitle(title: string) {
  let maxLength = 30
  if (sessionTags.value.length > 20) {
    maxLength = 5
  } else if (sessionTags.value.length > 15) {
    maxLength = 10
  } else if (sessionTags.value.length > 10) {
    maxLength = 15
  }
  return title.length > maxLength ? `${title.substring(0, maxLength)}...` : title
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterDays), (day) => {
          return (_openBlock(), _createElementBlock("div", {
            key: day.value,
            class: "mt-2"
          }, [
            _createVNode(BsCheckbox, {
              label: day.label,
              "onUpdate:modelValue": ($event: any) => (updateDayFilter(day))
            }, null, 8, ["label", "onUpdate:modelValue"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterTimes), (time) => {
        return (_openBlock(), _createElementBlock("div", {
          key: time.value,
          class: "mt-2"
        }, [
          _createVNode(BsCheckbox, {
            label: time.label,
            "onUpdate:modelValue": ($event: any) => (updateTimeFilter(time))
          }, null, 8, ["label", "onUpdate:modelValue"])
        ]))
      }), 128))
    ]),
    (sessionTags.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sessionTags.value, (tag) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tag.abbreviation,
                class: "mt-2"
              }, [
                _createVNode(BsCheckbox, {
                  "onUpdate:modelValue": ($event: any) => (updateTagFilter(tag))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("span", {
                        title: getShortenedTagTitle(tag.title) !== tag.title ? tag.title : ''
                      }, _toDisplayString(getShortenedTagTitle(tag.title)) + " (" + _toDisplayString(tag.abbreviation) + ") ", 9, _hoisted_9),
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(InfoCircle, { class: "ms-1 align-bottom" }),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(tag.description), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onUpdate:modelValue"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})